// Helper function to validate password
export const validatePassword = (password: any) => {
  return password.length >= 6; // Assuming password should have at least 6 characters
};
